// extracted by mini-css-extract-plugin
module.exports = {"content":"mdx-content_content__Gpu2H"};